// this is an overcome for not updated redux-store
// TODO: fix on code freeze https://app.asana.com/0/0/1205107468358935/f
import { Provider } from 'react-redux';
import { ComponentType, ReactNode } from 'react';

type Props = Provider['props'] & { children: ReactNode };

export const ProviderCasted = Provider as ComponentType<Props>;
